import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { COMPONENTS } from 'site-modules/personalized-search/constants/components';
import { SearchRenderer } from 'site-modules/personalized-search/search-renderer/search-renderer';

export function Links({ componentParams: links, creativeId, componentPath, onRendered = noop }) {
  useEffect(() => {
    onRendered();
  }, [onRendered]);

  return (
    <section className="links pb-1 mt-2" data-tracking-parent={creativeId}>
      <div className="base-inner-width px-1 px-md-0_5 px-lg-0 mx-md-auto">
        <h2 className="size-20 fw-bold mb-1">Related links</h2>
        <ul className="list-unstyled m-0">
          {links.map((link, idx) => (
            <SearchRenderer
              // eslint-disable-next-line react/no-array-index-key
              key={idx}
              componentParams={link}
              parentComponentName={COMPONENTS.LINKS}
              componentPath={componentPath}
              order={idx + 1}
            />
          ))}
        </ul>
      </div>
    </section>
  );
}

Links.propTypes = {
  componentParams: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  creativeId: PropTypes.string.isRequired,
  componentPath: PropTypes.string.isRequired,
  onRendered: PropTypes.func,
};
